import { createFileRoute } from '@tanstack/react-router'
import BundleContainerErp from 'Bundle/containers/BundleContainerErp'

export const Route = createFileRoute('/bundle/_main/erp/$productId')({
    component: BundleContainerErp,
})
